import { z } from "zod";
import { TimestampSchema } from "../epoch";
export const IdentityLevelSchema = z.union([
    z.literal(1),
    z.literal(2),
    z.literal(3),
]);
export const IdentityLevelValueSchema = z.enum([
    "level1_silver",
    "level2_onchain",
    "level3_kyc",
]);
export const NameServiceProofSchema = z.strictObject({
    provider: z.enum(["ens"]),
    chainId: z.literal(1),
    name: z.string().min(1).max(255),
    address: z.string().regex(/^0x[a-fA-F0-9]{40}$/),
    resolvedAt: TimestampSchema,
    expiresAt: TimestampSchema,
});
export const IdentityMetadataSchema = z
    .strictObject({
    authWalletAddress: z.string().regex(/^0x[a-fA-F0-9]{40}$/),
    nameService: NameServiceProofSchema.optional(),
})
    .partial();
export function getIdentityLevelValue(level) {
    if (level === 3)
        return "level3_kyc";
    if (level === 2)
        return "level2_onchain";
    return "level1_silver";
}
export function deriveIdentityLevel(profile) {
    const authWalletAddress = profile.authWalletAddress ?? profile.identity?.authWalletAddress ?? profile.id;
    if (!authWalletAddress) {
        return 1;
    }
    return profile.verified ? 3 : 2;
}
